import styled from 'styled-components';

export const FiltersDetailsContentSkeletonsStyle = {
  Container: styled.div`
    display: flex;
    align-items: center;
  `,
  Column: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 14px;
  `,
  Title: styled.div`
    margin-bottom: 4px;
  `,
};
